module.exports = __webpack_public_path__ + "img/bvi_1.bdb8e17e.png";